// Single source of truth for football's front-end identifiers — the uploader (Upload.tsx), the
// sportId -> activity map (api/adapters.ts) and the results viewer (mockData.ts) all reference these,
// so casing/spelling can't drift between them. (Backend equivalent: NetCoreInterfaces/FootballConstants.cs.)

export const FOOTBALL_GROUP = "Football";
export const FOOTBALL_EMOJI = "⚽";

/** Numeric sportIds — mirror NetCoreInterfaces.SportId (footballPenalty=39, footballFreeKick=40, footballCorner=41). */
export const FOOTBALL_SPORT_IDS = {
  penalty: 39,
  freeKick: 40,
  corner: 41,
} as const;

/** ActivityId string keys used by the results viewer. */
export const FOOTBALL_ACTIVITIES = {
  penalty: "footballPenalty",
  freeKick: "footballFreeKick",
  corner: "footballCorner",
} as const;
export type FootballActivityId = (typeof FOOTBALL_ACTIVITIES)[keyof typeof FOOTBALL_ACTIVITIES];

/** Upload-picker options (label shown in the sport grid). */
export const FOOTBALL_UPLOAD_OPTIONS = [
  { id: FOOTBALL_SPORT_IDS.penalty,  label: "Penalty" },
  { id: FOOTBALL_SPORT_IDS.freeKick, label: "Free Kick" },
  { id: FOOTBALL_SPORT_IDS.corner,   label: "Corner" },
] as const;

/** Results-viewer activity rows (label + phase count). */
export const FOOTBALL_ACTIVITY_META = [
  { id: FOOTBALL_ACTIVITIES.penalty,  label: "Football — Penalty",   positions: 5 },
  { id: FOOTBALL_ACTIVITIES.freeKick, label: "Football — Free Kick", positions: 5 },
  { id: FOOTBALL_ACTIVITIES.corner,   label: "Football — Corner",    positions: 5 },
] as const;

/** The five body-pose phases of a struck dead ball (mirrors SetFinder_Football's GetPositionLabel).
 *  Structurally compatible with mockData's ActivityPhase (kept import-free to avoid a cycle). */
export const FOOTBALL_PHASES: { id: string; label: string; pct: number; cue?: string }[] = [
  { id: "P1", label: "Set-Up",         pct: 0,   cue: "Balanced over your base" },
  { id: "P2", label: "Plant",          pct: 25,  cue: "Standing foot planted, knee braced" },
  { id: "P3", label: "Backswing",      pct: 50,  cue: "Kicking leg cocked back to load power" },
  { id: "P4", label: "Strike",         pct: 75,  cue: "Leg driven straight through the ball" },
  { id: "P5", label: "Follow-Through", pct: 100, cue: "Leg swings up and through" },
];
